module.exports = __webpack_public_path__ + "static/media/ic_tick_visitor.d112e2fc.svg";